(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["delivery-checker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('htc-delivery-checker')) {
  customElements.define('htc-delivery-checker', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.postcode = this.querySelector('[data-postcode]');
      this.suburb = this.querySelector('[data-suburb]');
      this.suburbWrap = this.querySelector('[data-suburb-wrap]');
      this.result = this.querySelector('[data-result]');
      this.addButton = this.closest('.range-info')?.querySelector('button[name="add"]');
      this.available = this.addButton ? !this.addButton.disabled : false;
      this.rows = new Map();
      this.querySelectorAll('tbody tr').forEach(row => {
        const cells = row.querySelectorAll('td');
        if (cells.length !== 2) return;
        const code = cells[0].textContent.trim();
        const names = cells[1].textContent.split(',').map(name => name.trim()).filter(Boolean);
        this.rows.set(code, names);
      });
      this.querySelector('[data-check]').addEventListener('click', () => this.check());
      this.postcode.addEventListener('keydown', event => {
        if (event.key === 'Enter') { event.preventDefault(); this.check(); }
      });
      this.postcode.addEventListener('input', () => {
        this.suburbWrap.hidden = true;
        this.suburb.value = '';
        this.postcode.removeAttribute('aria-invalid');
        this.show('reset', this.dataset.reset, true);
      });
      this.suburb.addEventListener('change', () => {
        if (!this.suburb.value) this.show('choose', this.dataset.choose, true);
        else if (this.suburb.value === 'other') this.show('ok', this.dataset.ok, false);
        else this.show('blocked', this.dataset.blocked, true);
      });
      this.addButton?.form?.addEventListener('submit', event => {
        if (this.preventAdd) { event.preventDefault(); this.postcode.focus(); }
      });
    }
    show(state, message, preventAdd) {
      this.result.textContent = message;
      this.result.dataset.state = state;
      this.preventAdd = preventAdd;
      if (this.addButton) this.addButton.disabled = !this.available || preventAdd;
    }
    check() {
      const code = this.postcode.value.trim();
      this.suburbWrap.hidden = true;
      if (!/^[0-9]{4}$/.test(code) || Number(code) < 200 || Number(code) > 9999 || code === '9999') {
        this.postcode.setAttribute('aria-invalid', 'true');
        this.show('invalid', this.dataset.invalid, true);
        return;
      }
      this.postcode.removeAttribute('aria-invalid');
      if (!this.rows.size) { this.show('invalid', this.dataset.reset, true); return; }
      const excluded = this.rows.get(code);
      if (!excluded) { this.show('ok', this.dataset.ok, false); return; }
      this.suburb.querySelectorAll('[data-excluded]').forEach(option => option.remove());
      excluded.forEach(name => {
        const option = document.createElement('option');
        option.value = name;
        option.textContent = name;
        option.dataset.excluded = '';
        this.suburb.insertBefore(option, this.suburb.querySelector('[value="other"]'));
      });
      this.suburb.value = '';
      this.suburbWrap.hidden = false;
      this.show('choose', this.dataset.choose, true);
      this.suburb.focus();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
